import jsPDF from 'jspdf';
import ColorConverter from '../tools/HexadecimalConvertor';
import { format } from 'date-fns';
import 'jspdf-autotable';

const PDFGenerator = (items, genId, taskGenId, name) => {

    const pdf = new jsPDF();
    const userData = localStorage.getItem("UserData");
    let parsedUser;
    parsedUser = JSON.parse(userData);
    // Prepare The Font
    const font = "Newsreader";
    const company = 'Task Manager Team'
    // header Image
    const headerImage = "../../../image/icons/letter.jpg";
    pdf.addImage(headerImage, 'JPG', 10, 10, 190, 43);

    // prepare in here a line
    pdf.setLineWidth(0.1);
    // Line color (RGB)
    pdf.setDrawColor(200, 200, 200);
    pdf.line(10, 55, 200, 55)


    pdf.setFontSize(10);
    pdf.setFont(`${font}`, 'normal');
    pdf.text('Task Material Details', 10, 60);
    pdf.text('Invo No: ', 10, 66);
    pdf.text(genId, 25, 66);
    pdf.text('Task ID: ', 10, 72);
    pdf.text(taskGenId, 25, 72);
    pdf.text('Consumer: ', 10, 78);
    pdf.text(name, 27, 78);
    pdf.text(`Date On: ${format(new Date(), 'MMM dd, yyyy')}`, 166, 60);

    pdf.setFont(`${font}`, 'bold')
    pdf.text('Dear: ', 10, 90)
    pdf.text(`${company}`, 21, 90)

    pdf.setFontSize(11);
    pdf.setFont(`${font}`, 'normal');

    const text = `We hope this message finds you well. We have reviewed your request for the following materials to the task id mentioned above and we are pleased to inform you that your requested items have been approved. However, please note that some quantities may not be completed due to insufficient stock in the store, or some of your requested items may not have been approved for the same reason.`;

    const Text = text && text !== "" && text.trim();
    const splitTexts = pdf.splitTextToSize(Text, 185);
    const lineHeight = 5.5;

    splitTexts.forEach((line, index) => {
        pdf.text(line, 10, 98 + (index * lineHeight));
    });



    const itemDetailsRows = items.map((item, index) => [
        (index + 1).toString(),
        item.name.toString(),
        item.recievedQty.toString(),
        item.recievedQty > 0 ? "Approved" : "Unapproved",
    ]);


    const itemDetailsHeaders = ['No', 'Name', 'Quantity', 'Approved'];
    const columnWidths = [15, 60, 79, 30];

    const headerStyles = {
        fillColor: [...ColorConverter('#e9ecef')],
        textColor: [0],
        fontFamily: `${font}`,
        fontStyle: 'bold',
    };

    pdf.setFont(`${font}`);

    pdf.autoTable({
        head: [itemDetailsHeaders],
        body: itemDetailsRows,
        startY: 125,
        headStyles: {
            fillColor: headerStyles.fillColor,
            textColor: headerStyles.textColor,
            fontStyle: headerStyles.fontStyle,
            fontSize: 10,
            font: font,
            halign: 'left',
        },
        columnStyles: {
            0: { cellWidth: columnWidths[0] },
            1: { cellWidth: columnWidths[1] },
            2: { cellWidth: columnWidths[2] },
            3: { cellWidth: columnWidths[3] },
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        bodyStyles: {
            fontSize: 10,
            font: font,
            cellPadding: { top: 1, right: 5, bottom: 1, left: 2 },
            textColor: [0, 0, 0],
            rowPageBreak: 'avoid',
            halign: 'left',
        },
        margin: { top: 10, left: 10 },
        didDrawCell: function (data) {
            const cell = data.cell;
            if (cell.section === 'body' && data.row.index !== undefined && data.row.index !== itemDetailsRows.length - 1) {
                const lineWidth = 0.7;
                const { x, y, width, height } = cell;
                pdf.setDrawColor(...ColorConverter('#e9ecef'));
                pdf.setLineWidth(lineWidth);
                pdf.line(x, y + height, x + width, y + height);
            }
        },
    });

    const summaryYStart = pdf.internal.pageSize.getHeight() - 50;
    
    pdf.setFont('Newsreader', 'noraml')
    pdf.text('Signatured, _________________', 13, summaryYStart + 8)
    pdf.text('Thanking You,', 13, summaryYStart + 18)
    pdf.text('Yours Faithfully,', 13, summaryYStart + 23)
    pdf.text('For ', 13, summaryYStart + 28)
    pdf.setFont('Newsreader', 'bold')
    pdf.text('The Palms Hotel', 19, summaryYStart + 28)

    pdf.setProperties({
        title: "Approved Materials"
    })

    const totalPages = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setFont('Newsreader', 'normal');
        pdf.text(`Page ${i} of ${totalPages}`, pdf.internal.pageSize.width - 10, pdf.internal.pageSize.height - 8, { align: 'right' });
        pdf.setDrawColor(...ColorConverter('#adb5bd'))
        pdf.line(10, 283, 200, 283)
        pdf.setTextColor(...ColorConverter('#0000000'))
        pdf.setFont(`${font}`, "italic")
        pdf.text(`Prepared By:${parsedUser?.name}`, 10, pdf.internal.pageSize.height - 8)

    }

   


    return pdf.save(`${items && items.length > 0 ? "Approved Materials" : 'Approved Materials'}.pdf`);
}


export default PDFGenerator;

